export const MODAL_BASE_STYLE = {
  position: "absolute",
  inset: 0,
  margin: "auto",
  bgcolor: "background.paper",
  borderRadius: 1,
  boxShadow: 24,
  outline: "none",
  display: "flex",
  flexDirection: "column",
  transition: ".6s 0.3s var(--easing-spring) !important",

  "@starting-style": {
    "&": {
      scale: 0.9,
    },
  },
} as const;

export const MODAL_LARGE_STYLE = {
  width: "90vw",
  maxWidth: "700px",
  height: "90vh",
  maxHeight: "900px",
} as const;

export const MODAL_FIT_STYLE = {
  ...MODAL_LARGE_STYLE,
  width: "fit-content",
  height: "fit-content",
  maxWidth: "90%",
  maxHeight: "90%",
} as const;

export const MODAL_FADE_TIMEOUT = {
  enter: 225,
  exit: 0,
} as const;

export const MODAL_SLOT_PROPS = {
  backdrop: {
    timeout: { enter: 500, exit: 0 },
    className: "backdrop-blur-xs",
  },
} as const;
